import React, { useState } from "react";
import "./PaintCalculator.css";
import paintImage from "../assets/paintCalculatorImg.png";

export default function PaintCalculator() {
  const [walls, setWalls] = useState([
    { height: "", width: "" },
    { height: "", width: "" },
  ]);

  const coveragePerLiter = 10; 
  const coats = 2; 

  const handleChange = (index, field, value) => {
    const updatedWalls = [...walls];
    updatedWalls[index][field] = value;
    setWalls(updatedWalls);
  };

  const addWall = () => {
    setWalls([...walls, { height: "", width: "" }]);
  };

  const removeWall = (index) => {
    if (walls.length > 2) {
      setWalls(walls.filter((_, i) => i !== index));
    }
  };

  const calculatePaint = () => {
    const totalArea = walls.reduce((acc, wall) => {
      const h = parseFloat(wall.height) || 0;
      const w = parseFloat(wall.width) || 0;
      return acc + h * w;
    }, 0);

    const paintNeeded = (totalArea / coveragePerLiter) * coats;
    return paintNeeded.toFixed(2);
  };

  return (
    <section className="paint-calculator">
      <h2>Paint Calculator</h2>
      <p>
        Paint calculator simplifies your project by accurately measuring the
        needed paint, making painting easier.
      </p>

      <div className="calc-container">
        {/* LEFT IMAGE */}
        <div className="calc-image">
          <img src={paintImage} alt="Paint illustration" />
        </div>

        {/* RIGHT FORM */}
        <div className="calc-form">
          {walls.map((wall, index) => (
            <div key={index} className="wall-input">
              <div className="input-row">
                <div className="input-group">
                  <label>Height of the area (m):</label>
                  <input
                    type="number"
                    min="0"
                    value={wall.height}
                    placeholder="Enter height"
                    onChange={(e) =>
                      handleChange(index, "height", e.target.value)
                    }
                  />
                </div>
                <div className="input-group">
                  <label>Width of the area (m):</label>
                  <div className="width-with-remove">
                    <input
                      type="number"
                      min="0"
                      value={wall.width}
                      placeholder="Enter width"
                      onChange={(e) =>
                        handleChange(index, "width", e.target.value)
                      }
                    />
                    <button
                      className="remove-btn"
                      onClick={() => removeWall(index)}
                      disabled={walls.length === 2}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* ✅ Result */}
          {/* <div className="paint-output2">
            Note: These are rough estimates which takes into account 2 coats per wall.
          </div> */}
          <div className="paint-output">
            Quantity (Ltr) of Paint Needed: {calculatePaint()} Ltr
          </div>

          {/* Add wall button */}
          <button className="add-btn" onClick={addWall}>
            Add New Wall
          </button>
          <div className="paint-output2">
            Note: These are rough estimates which takes into account 2 coats per
            wall.
          </div>
        </div>
      </div>
    </section>
  );
}
